import React, { useEffect, useState, useRef } from 'react';
import { Box, Button, Grid, TextField, Typography, Select, MenuItem, SelectChangeEvent, useTheme, } from '@mui/material'; // Import Select and MenuItem
import axios, { AxiosResponse } from 'axios';
import { Safetylogfields } from '../../constants/Safetylogfields';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../theme/theme';
import SignatureCanvas from 'react-signature-canvas';
import { BASEURL, SIGN_FONT, ARROW, FONT_SIZE, AUTOFILL_STYLES } from "../../constants/Common";
import { safetylogs } from './Safetylogs';
import FloatingButton from '../../pages/usersupport/helpdesk/FloatingButton';

interface ProjectNames {
  id: number;
  project_name: string;
  project_status: string;
}
interface User {
  id: number;
  username: string;
}

const CreateNewSafetylogPage: React.FC = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [signatureData, setSignatureData] = useState('');
  const [projectNamesData, setProjectNamesData] = useState<ProjectNames[]>([]);
  const [selectedFiles, setSelectedFiles] = useState<File[]>([]);
  const [assignedUsers, setAssignedUsers] = useState<string[]>([]); // Users assigned to the selected project
  const [selectedProjectId, setSelectedProjectId] = useState<number | ''>('');
  const mergedListRef = useRef(0);
  const today = new Date().toISOString().slice(0, 10);
  const location = useLocation();
  const orgid = localStorage.getItem('orgid');
  const userid = localStorage.getItem('userid');
  const username = localStorage.getItem('username');
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    let argProjectNames = location?.state?.projectNameList;
    if (argProjectNames !== undefined) {
      setProjectNamesData(argProjectNames);
    }
    if (mergedListRef.current === 0) {  //use this condition to fetch and populate list only one time
      fetchAssignedUsers(selectedProjectId);
      mergedListRef.current = 1
    }

  }, []);

  const fetchAssignedUsers = async (projectId: any) => {
    try {
      const response = await axios.get(`${BASEURL}/api/assignedusers/${projectId}/?orgid=${orgid}&userid=${userid}`,
        {
          headers: { 'Content-Type': 'multipart/form-data', },
        }
      );
      if (response.status === 200) {
        const assignedUsersList = response.data.users;
        setAssignedUsers(assignedUsersList.map((user: any) => user.username));
        console.log(assignedUsers)
      }
    } catch (error) {
      console.error('Error fetching assigned users:', error);
    }
  };


  const [newdata, setNewdata] = useState<safetylogs>({
    id: null,
    logno: '',
    assignedto: '',
    createddate: today,
    status: '',
    title: '',
    description: '',
    projectcode: '',
    createdby: username ? username : '',
    remarks: '',
    projectname: '',
    attachments: null,
    attachments2: null,
    attachments3: null,
    attachments4: null,
    attachments5: null,
    attachments6: null,
    project_id: '',
    signature: '',
    initials: '',
  });

  const handleInputChange = (
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> | SelectChangeEvent<string>
  ) => {
    if (event.target.name === "projectname") {
      const valueProjectID = parseInt(event.target.value);

      const selProjectNameArray = projectNamesData.find(project => project.id === valueProjectID);
      if (selProjectNameArray) {
        const selProjectName = selProjectNameArray.project_name;

        setNewdata((prevState) => ({
          ...prevState!,
          projectname: selProjectName,
          project_id: event.target.value
        }));

        // Fetch assigned users for the selected project
        fetchAssignedUsers(valueProjectID);
        setSelectedProjectId(valueProjectID);
      }
    } else {
      const { name, value } = event.target as HTMLInputElement | HTMLTextAreaElement;
      setNewdata({ ...newdata, [name]: value });
    }
  };

  const validateInput = () => {
    if (newdata.logno.length == 0) {
      toast.error("Please enter Log number.")
      return false;
    }
    if (newdata.title.length == 0) {
      toast.error("Please enter safetylog title.")
      return false;
    }
    if (newdata.projectname.length == 0) {
      toast.error("Please select project name.")
      return false;
    }
    if (newdata.assignedto.length == 0) {
      toast.error("Please select assignedto value.")
      return false;
    }
    if (newdata.status.length == 0) {
      toast.error("Please select the safetylog status.")
      return false;
    }
    if (newdata.createdby.length == 0) {
      toast.error("Please enter the created by value.")
      return false;
    }
    if (newdata.createddate.length == 0) {
      toast.error("Please enter created date value.")
      return false;
    }
    if (newdata.remarks.length == 0) {
      toast.error("Please enter Remarks.")
      return false;
    }
    if (newdata.initials.length == 0) {
      toast.error("Signature is required.")
      return false;
    }
    return true
  }


  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    setIsSaving(true);
    try {

      newdata.attachments = selectedFiles[0]
      newdata.attachments2 = selectedFiles[1]
      newdata.attachments3 = selectedFiles[2]
      newdata.attachments4 = selectedFiles[3]
      newdata.attachments5 = selectedFiles[4]
      newdata.attachments6 = selectedFiles[5]

      let ret = validateInput()
      if (!ret) {
        setIsSaving(false);
        return
      }
      newdata.signature = signatureData;

      const url_create = BASEURL + '/safetylogs/create/';
      const response = await axios.post(url_create, newdata, {
        headers: { 'Content-Type': 'multipart/form-data', },
      });
      toast.success('Safety log created successfully');

      const newid = response?.data.trackingid;

      newdata.id = newid;
      newdata.remarks = '';
      newdata.attachments = null;
      newdata.attachments2 = null;
      newdata.attachments3 = null;
      newdata.attachments4 = null;
      newdata.attachments5 = null;
      newdata.attachments6 = null;
      newdata.initials = ''

      navigate('/safetylog-details', { state: { logDetails: newdata, projectNamesData: projectNamesData } });

    } catch (error) {
      toast.error('Error creating new safety log');
      setIsSaving(false);
    }
  };

  const handleCancelClick = () => {
    navigate('/safetylogs')
  }

  const handleFilesChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(event.target.files!) as File[];

    const uniqueFilesToAdd = newFiles.filter((file) => !selectedFiles.some((selectedFile) => selectedFile.name === file.name));

    if ((uniqueFilesToAdd.length + selectedFiles.length) > 6) {
      toast.error('You can only upload up to 6 files.');
      return;
    }

    setSelectedFiles((prevFiles) => [...prevFiles, ...uniqueFilesToAdd]);

  };


  const handleRemoveFile = (fileName: string) => {
    setSelectedFiles((prevFiles) => prevFiles.filter((file) => file.name !== fileName));
  };

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files;
    if (files && files.length > 0) {
    }
  };

  const handleButtonClick = (evt: any) => {
    evt.preventDefault();

    if (selectedFiles.length > 5)
      toast.error("You can upload maximum of 6 files.")
    else {
      let obj = document.getElementById('fileInput');
      if (obj != null)
        obj.click();
    }
  };

  return (
    <ThemeProvider theme={getTheme()}>
      <Box sx={{ mt: '-80px' }}>
        <Typography variant='h6' gutterBottom>
          <Link to={'/safetylogs'} >Safety logs</Link>{ARROW} Create New
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container alignItems="center" spacing={1}>
            {Safetylogfields.map((field) => (
              !['projectcode'].includes(field.name) && (
                <React.Fragment key={field.name}>
                  <Grid item xs={12} sm={6} md={3}>
                    <Typography><strong>{field.title}</strong>{['description', 'attachments'].includes(field.name) && ' (optional)'}</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={3}>

                    {field.type === 'dropDown' ? (
                      <Box sx={{ mt: "15px", border: '1px solid #000000' }}>

                        {field.name === "projectname" ? (
                          <Select
                            value={newdata.project_id !== null ? newdata.project_id : ''}
                            onChange={handleInputChange}
                            fullWidth
                            variant='outlined'
                            name={field.name}
                          >
                            {projectNamesData.filter(project => project.project_status !== "Completed").map((project, index) => (
                              <MenuItem key={index} value={project.id}
                                sx={{
                                  color: '#000000',
                                  fontSize: '18px',
                                }}>
                                {project.project_name}
                              </MenuItem>
                            ))}
                          </Select>
                        ) : field.name === "assignedto" ? (
                          <Select
                            value={newdata.assignedto}
                            onChange={handleInputChange}
                            fullWidth
                            variant='outlined'
                            name={field.name}
                          >
                            {assignedUsers.length === 0 && (
                              <MenuItem disabled value="">
                                <em>Select a project to assign user</em>
                              </MenuItem>
                            )}
                            {assignedUsers.map((type: string) => (
                              <MenuItem
                                key={type}
                                value={type}
                                sx={{
                                  color: '#000000',
                                  fontSize: '18px',
                                  backgroundColor: newdata.assignedto === type ? '#d3d3d3' : 'inherit',
                                }}
                              >
                                {type}
                              </MenuItem>
                            ))}
                          </Select>
                        )
                          : field.name === "status" ? (
                            <Select
                              value={newdata.status}
                              onChange={handleInputChange}
                              fullWidth
                              variant='outlined'
                              name={field.name}
                            >
                              {field.options?.map((option, index) => (
                                <MenuItem key={index} value={option}
                                  sx={{
                                    color: '#000000',
                                    fontSize: '18px',
                                  }}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          ) : (
                            <Select
                              value={newdata[field.name] !== null ? newdata[field.name] as string : ''}
                              onChange={handleInputChange}
                              fullWidth
                              variant='outlined'
                              name={field.name}
                            >
                              {field.options?.map((option, index) => (
                                <MenuItem key={index} value={option}>
                                  {option}
                                </MenuItem>
                              ))}
                            </Select>
                          )}
                      </Box>

                    ) : field.name === 'description' ? (
                      <TextField
                        name={field.name}
                        value={newdata[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                        multiline
                        rows={field.height}
                      />
                    ) : field.name === 'remarks' ? (
                      <TextField
                        name={field.name}
                        value={newdata[field.name]}
                        onChange={handleInputChange}
                        fullWidth
                        margin='normal'
                        variant='outlined'
                        multiline
                        rows={field.height}
                      />
                    ) : field.name === 'attachments' ? (
                      <Box sx={{ mt: '15px', width: '300px', }}>
                        <input id="fileInput"
                          type="file"
                          name="file"
                          onChange={handleFilesChange}
                          accept=".jpg, .jpeg, .png"
                          multiple
                          style={{ display: 'none' }}
                        />
                        <Button variant='contained' color='primary' onClick={handleButtonClick}>Browse</Button>
                      
                        {selectedFiles.map((file: any) => (
                          <div key={file.name}>
                            <Grid mt={1} container spacing={0} sx={{ mt: 1 }}>
                              <Grid item md={6} xs={12} sx={{ wordWrap: 'break-word' }}>
                                <span style={{ display: 'block', overflowWrap: 'break-word' }}>{file.name}</span>
                              </Grid>
                              <Grid item md={3} xs={12} style={{ marginLeft: '0px' }}>
                                <Button color='error'
                                 variant='text' onClick={() => handleRemoveFile(file.name)}
                                 sx={{ mt: { xs: 1, md: 0 } }}>Remove</Button>
                              </Grid>
                            </Grid>
                          </div>
                        ))}

                      </Box>
                    ) : field.name === 'signature' ? (

                      <div style={{
                        display: 'flex', flexDirection: 'column', border: '1px solid #ccc',
                        paddingLeft: 5, paddingRight: 5, paddingBottom: 5, paddingTop: 0,
                      }}> {/* Wrap Sign in flex container with column layout and border */}

                        <TextField
                          name={'initials'} type={'text'} value={newdata['initials']}
                          onChange={handleInputChange}
                          fullWidth margin='dense' variant='outlined'
                          sx={{
                            ...AUTOFILL_STYLES(theme),
                          }}
                        />

                        <span style={{
                          fontFamily: SIGN_FONT, minHeight: '50px', maxWidth: '100%', whiteSpace: 'pre-wrap',
                          fontSize: FONT_SIZE, border: '2px solid #ccc', padding: 5
                        }}>
                          {newdata['initials']}
                        </span>
                      </div>
                    )
                      : field.name === 'createdby' ? (
                        <Box sx={{ mt: '15px' }}>
                          {newdata.createdby}
                        </Box>
                      ) : field.name === 'createddate' ? (
                        <Box sx={{ mt: '15px' }}>
                          {newdata.createddate}
                        </Box>
                      )
                        : (
                          <TextField
                            name={field.name}
                            type={
                              field.type === 'date'
                                ? 'date'
                                : field.type === 'dropzone'
                                  ? 'dropzone'
                                  : 'text'
                            }
                            value={newdata[field.name]}
                            onChange={handleInputChange}
                            fullWidth
                            margin='normal'
                            variant='outlined'
                            sx={{
                              ...AUTOFILL_STYLES(theme),
                            }}
                          />
                        )}

                  </Grid>
                </React.Fragment>
              )

            ))}


          </Grid>

          <Box sx={{ mt: '50px', display: 'flex', justifyContent: 'flex-end' }}>
            <Button type='submit' variant='contained' color='primary'
              sx={{ marginRight: '20px', width: '75px', '&:disabled': { bgcolor: 'grey.400', color: 'grey.700' } }}
              disabled={isSaving}
            >
              Save
            </Button>
            <Button
              variant='contained'
              onClick={handleCancelClick}
              sx={{ width: '75px' }}
            >
              Cancel
            </Button>

          </Box>
        </form>
        <FloatingButton />
      </Box>
    </ThemeProvider>
  );
};

export default CreateNewSafetylogPage;